import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  ReferenceField,
  useRefresh,
  useUnselectAll,
  TextInput,
  Filter,
  ReferenceInput,
  AutocompleteInput
} from 'react-admin';
import {Button, IconButton, InputAdornment, InputBase} from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {stopSessions} from "../../api";

function SessionsList(props: any) {

  return (
    <List {...props}
          title="VM Sessions"
          bulkActionButtons={<SessionsBulkActionButtons/>}
          filters={<SessionFilter />}
    >
      <Datagrid optimized>
        <ReferenceField label="Customer" source="customerId" reference="customers" link="show">
          <TextField source="companyName"/>
        </ReferenceField>
        <ReferenceField label="Created by" source="createdByUserId" reference="users" link="show">
          <TextField source="name"/>
        </ReferenceField>
        <ReferenceField label="Started by" source="startedByUserId" reference="users" link="show">
          <TextField source="name"/>
        </ReferenceField>
        <TextField source="template.model" label="Template Model"/>
        <TextField source="template.edition" label="Template Edition"/>
        <TextField source="machineState"/>
        <TextField source="connectionDetails.vpnUser" label="VPN User"/>
        <FunctionField
          source="connectionDetails.vpnPassword"
          label="VPN Password"
          sortable={false}
          render={ (record: any) => {
          return record.connectionDetails ? <PasswordField text={record.connectionDetails.vpnPassword ?? ''}/> : ''
        }} />
        <TextField source="publicIP" label="Public IP"/>
        <TextField source="startTime"/>
      </Datagrid>
    </List>
  )
}

export const PasswordField = (props: { text: string }) => {
  const { text } = props;
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = (event: any) => {
    event.stopPropagation()
    setShowPassword(!showPassword)
  };

  return(
    <InputBase
      disabled
      value={text}
      type={ showPassword ? 'text' : 'password'}
      style={{minWidth: 160}}
      endAdornment={
        <InputAdornment position="start">
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            edge="start"
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
}

const SessionsBulkActionButtons = (props: any) => (
  <>
    <StopSessionsButton label="Stop sessions" {...props} />
  </>
);

const StopSessionsButton = (props: { selectedIds: number[], label: string }) => {

  const refresh = useRefresh()
  const unselect = useUnselectAll()
  return (
    <Button
      endIcon={<HighlightOffIcon />}
      color="primary"
      onClick={() => {
        stopSessions(props.selectedIds)
        unselect('vm/admin')
        refresh()
      }}
    >
      {props.label}
    </Button>
  );
}

const SessionFilter = (props: any) => (
  <Filter {...props} >
    <TextInput label="Search" source="search" alwaysOn variant="outlined"/>
    <ReferenceInput label="Customer" source="customerId" reference="customers" variant="outlined">
      <AutocompleteInput optionText="companyName"/>
    </ReferenceInput>
    <ReferenceInput label="Created by" source="createdByUserId" reference="users" variant="outlined">
      <AutocompleteInput optionText="name"/>
    </ReferenceInput>
    <ReferenceInput label="Started by" source="startedByUserId" reference="users" variant="outlined">
      <AutocompleteInput optionText="name"/>
    </ReferenceInput>
    <TextInput source="template.model" label="Template Model" variant="outlined"/>
    <TextInput source="template.edition" label="Template Edition" variant="outlined"/>
    <TextInput source="machineState" variant="outlined"/>
    <TextInput source="publicIP" variant="outlined"/>
  </Filter>
);

export default SessionsList